module.exports = __webpack_public_path__ + "img/56.0be31af9.png";